import {h, Fragment} from "preact"
import { InfiniteScroll, useAppState } from "@nosto/preact"

import NoResults from "./NoResults"
import Products from "./Products"
import Toolbar from "./Toolbar"
import ToolbarV2 from "./ToolbarV2"
import SelectedFiltersV2 from "./SelectedFiltersV2"
import Sidebar from "./Sidebar"
import BottomToolbar from "./BottomToolbar"
import { useEffect, useState } from "preact/hooks"

let categoryHeader;

if(document.querySelectorAll('.collection-grid__title').length > 0){
    categoryHeader = document.querySelectorAll('.collection-grid__title')[0].textContent;
} 

export default function Serp() {
    const {
        response: { products },
        loading
    } = useAppState()
    const foundProducts = products && products.total > 0
    const toggleButtonId = "toggle-mobile-sidebar"
    const [sidebarOpen, setSidebarOpen] = useState(false);

    function toggleSidebar(){
        setSidebarOpen((currentState)=>!currentState)
    }

    useEffect(() => {
        const body = document.body;
      
        if (sidebarOpen) {
          body.style.overflow = "hidden";
        } else {
          body.style.overflow = "auto";
        }
      
        // cleanup to restore overflow when component unmounts
        return () => {
          body.style.overflow = "auto";
        };
      }, [sidebarOpen]);

    return (
        <div
            class="ns-serp ns-category-page ns-d-flex ns-flex-column ns-flex-md-row ns-font-inherit ns-mx-auto"
            data-nosto-element="search"
        >
            {(foundProducts || (loading && foundProducts)) && <Sidebar toggleId={toggleButtonId} onToggleSidebar={toggleSidebar} isActive={sidebarOpen} />}
            <div
                class="ns-d-block ns-d-md-inline ns-w-100 ns-border-box ns-p-0"
                style={loading ? "position: relative;" : ""}
            >
                {foundProducts ? (
                    <>
                        {/* <Toolbar lableFor={toggleButtonId} onToggleSidebar={toggleSidebar} categoryHeader={categoryHeader} isSearch={false} /> */}
                        <div class="ns-header-controls">
                            <ToolbarV2 onToggleSidebar={toggleSidebar}/>
                            <SelectedFiltersV2/>
                        </div>
                        <InfiniteScroll>
                            <Products />
                        </InfiniteScroll>
                        {/* <BottomToolbar /> */}
                    </>
                ) : !loading ? (
                    <NoResults />
                ) : ''}

                {/* To enable InfiniteScroll - comment above block and uncomment below.
                    Don't forget to import InfiniteScroll component. */}
                {/* {foundProducts ? (
                    <>
                        <SelectedFilters />
                        <Toolbar />
                        <InfiniteScroll>
                            <Products />
                        </InfiniteScroll>
                    </>
                ) : loading ? (
                    <Loader />
                ) : (
                    <NoResults />
                )} */}
            </div>
        </div>
    )
}
